import {
  faEnvelope,
  faEye,
  faEyeSlash,
  faLock,
  faMobileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import md5 from "blueimp-md5";
import React from "react";
import { useSelector } from "react-redux";

import ToBack from "../components/ToBack";
import reducer from "../reducer";

export default function Edit() {
  const [state, dispatch] = React.useReducer(reducer, {
    current_password: "",
    password: "",
    password2: "",
    code: "",
    phone: "",
  });
  // eslint-disable-next-line
  const [err, setErr] = React.useState({
    old_password: false,
    new_password: false,
    password2: false,
    code: false,
    email: false,
    phone: false,
  });

  const [count, setCount] = React.useState({
    countdown: 60,
    flag: true,
  });

  const [hide, setHide] = React.useState(true);

  const [hide1, setHide1] = React.useState(true);

  const [hide2, setHide2] = React.useState(true);

  const [verifyType, setVerifyType] = React.useState("email"); // email or phone

  const auth = useSelector((state) => state.auth);
  const handleLogIn = async () => {
    location.href = "#/登录?id=1";
  };
  const handleRecover = async () => {
    if (!state.current_password || !state.password || !state.password2) {
      alert("请完整填写所需信息");
      return;
    }
    if (state.password !== state.password2) {
      alert("两次输入的新密码不一致");
      return;
    }

    if (verifyType === "email") {
      // 邮箱验证码验证逻辑
      fetch(
        `/crate-api/staging?option=filterBy-refId-tag-detail&refId=${auth.id}&tag=验证码&detail=${JSON.stringify({ category: "个人用户" })}`,
      )
        .then((response) => response.json())
        .then((res) => {
          res.forEach((item) => {
            if (state.code === item.detail.code) {
              fetch(`/gin-api/candidate/${auth.uuid}/${auth.id}?option=resetPassword`, {
                method: "PATCH",
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                  password: md5(state.password),
                  code: state.code,
                  email: auth.email,
                  category: "个人用户",
                }),
              }).then((response) => {
                if (response.status > 400) {
                  window.alert("操作失败，请稍后重试!");
                  return;
                }
                window.alert("操作成功");
                location.href = "#登录";
              });
            } else {
              console.log("验证码错误");
            }
          });
        });
    } else {
      // 手机验证码验证逻辑
      fetch("/gin-api/candidate/reset-password-by-phone-code", {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          phone: state.phone,
          code: state.code,
          password: md5(state.password),
        }),
      })
        .then((response) => {
          if (response.ok) {
            window.alert("密码修改成功，请重新登录");
            location.href = "#登录";
          } else {
            throw new Error("验证码错误或操作失败");
          }
        })
        .catch((err) => alert(err));
    }
  };
  // const handleCode = () => {
  //   fetch('/api/miscellaneous/captcha', {
  //     method: 'POST',
  //     headers: { 'content-type': 'application/json' },
  //     body: JSON.stringify({
  //       email: auth.email,
  //       tag: '个人用户',
  //     }),
  //   }).then((response) => {
  //     if (response.status === 200) alert('验证码已发送到您的邮箱');
  //     else alert('发送验证码失败，请稍后重试');
  //   });
  //   const code = setInterval(() => {
  //     if (count.countdown === 1) {
  //       clearInterval(code);
  //       setCount({
  //         flag: true,
  //         countdown: 60,
  //       });
  //     } else {
  //       setCount({
  //         flag: false,
  //         countdown: (count.countdown -= 1),
  //       });
  //     }
  //   }, 1000);
  // };
  const handleCode = () => {
    fetch("/crate-api/email/actions/send-mail-2-reset-password", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        refId: auth.id,
        email: auth.email,
        detail: { category: "个人用户" },
      }),
    }).then((response) => {
      if (response.status === 200) {
        setCount({
          flag: false,
          countdown: 60,
        });
        const timer = setInterval(() => {
          setCount((prev) => {
            if (prev.countdown <= 1) {
              clearInterval(timer);
              return {
                flag: true,
                countdown: 60,
              };
            }
            return {
              flag: false,
              countdown: prev.countdown - 1,
            };
          });
        }, 1000);
        alert("验证码已发送到您的邮箱");
      } else {
        alert("发送验证码失败，请稍后重试");
      }
    });
  };

  React.useEffect(() => {
    const auth = localStorage.getItem("auth");
    if (null === auth) location.href = "#/登录";
  }, []);

  const checkEmail = () => {
    if (auth.email === "") {
      return true;
    }
  };

  const onHide = (e) => {
    setHide(e);
  };

  const onHide1 = (e) => {
    setHide1(e);
  };

  const onHide2 = (e) => {
    setHide2(e);
  };

  const checkPhone = () => {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    return reg.test(state.phone);
  };

  const handleSendSmsCode = async () => {
    if (!checkPhone()) {
      alert("请输入正确的手机号");
      return;
    }

    try {
      const response = await fetch(`/gin-api/candidate?option=by-phone&phone=${state.phone}`);
      const user = await response.json();
      if (!user) {
        alert("该手机号码未注册");
        throw new Error("该手机号码未注册");
      }
    } catch (err) {
      console.error(err);
      return;
    }

    fetch("/gin-api/ephemeral/phone", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        phone: state.phone,
        purpose: "修改密码",
      }),
    })
      .then((response) => {
        if (response.ok) {
          setCount({
            flag: false,
            countdown: 60,
          });
          const timer = setInterval(() => {
            setCount((prev) => {
              if (prev.countdown <= 1) {
                clearInterval(timer);
                return {
                  flag: true,
                  countdown: 60,
                };
              }
              return {
                flag: false,
                countdown: prev.countdown - 1,
              };
            });
          }, 1000);
          alert("验证码已发送到您的手机");
        } else {
          throw new Error("发送失败，请稍后重试");
        }
      })
      .catch((err) => alert(err));
  };

  return (
    <>
      {auth === 0 ? (
        <div className="container-fluid">
          <ToBack href="#我的" category="我的简历" />
          <div className="chat-login">
            <h6>登录后可以修改密码</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="card user-radius mt-3">
            <ToBack />
            <div className="row mt-3 bg-transparent">
              <div className="col">
                <h5 className="text-center">修改密码</h5>
              </div>
            </div>
            <div className="row bg-transparent text-dark">
              <div className="col">
                <div className="card border-0 bg-transparent text-dark">
                  <div className="card-body card-p">
                    <div className="mb-3 text-center">
                      <button
                        className={`btn btn-sm mr-2 ${verifyType === "email" ? "btn-warning text-dark" : "btn-outline-primary text-primary"}`}
                        onClick={() => setVerifyType("email")}
                      >
                        邮箱验证码修改
                      </button>
                      <button
                        className={`btn btn-sm ${verifyType === "phone" ? "btn-warning text-dark" : "btn-outline-primary text-primary"}`}
                        onClick={() => setVerifyType("phone")}
                      >
                        手机验证码修改
                      </button>
                    </div>
                    <form>
                      {verifyType === "email" ? (
                        <>
                          {err.email && (
                            <small className="form-text text-danger">{err.email}</small>
                          )}
                          <div className="input-group row mb-3 input-group-lg input-control">
                            <div className="input-group-prepend ">
                              <span className="input-group-text bg-transparent border-0">
                                <FontAwesomeIcon icon={faEnvelope} fixedWidth />
                              </span>
                            </div>
                            <input
                              type="text"
                              readOnly="readonly"
                              name="email"
                              style={{ fontSize: 18 }}
                              value={auth.email}
                              className="form-control col border-0 bg-transparent input-f"
                              placeholder="电子邮箱"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          {err.phone && (
                            <small className="form-text text-danger">{err.phone}</small>
                          )}
                          <div className="input-group row mb-3 input-group-lg input-control">
                            <div className="input-group-prepend">
                              <span className="input-group-text bg-transparent border-0">
                                <FontAwesomeIcon icon={faMobileAlt} fixedWidth />
                              </span>
                            </div>
                            <input
                              type="text"
                              name="phone"
                              value={state.phone}
                              style={{ fontSize: 18 }}
                              className="form-control col border-0 bg-transparent input-f"
                              placeholder="手机号码"
                              onChange={(e) =>
                                dispatch({
                                  type: "set",
                                  payload: { key: "phone", value: e.target.value },
                                })
                              }
                            />
                          </div>
                        </>
                      )}
                      {err.old_password && (
                        <small className="form-text text-danger">{err.old_password}</small>
                      )}
                      <div className="input-group row mb-3 input-group-lg input-control">
                        <div className="input-group-prepend ">
                          <span className="input-group-text bg-transparent text-secondary  border-0">
                            <FontAwesomeIcon icon={faLock} fixedWidth />
                          </span>
                        </div>
                        <input
                          type={hide ? "password" : "text"}
                          name="old_password"
                          value={state.current_password}
                          autoComplete="off"
                          className="form-control col border-0 bg-transparent input-f"
                          style={{ fontSize: 18 }}
                          placeholder="请输入旧密码"
                          onChange={(e) =>
                            dispatch({
                              type: "set",
                              payload: {
                                key: "current_password",
                                value: e.target.value,
                              },
                            })
                          }
                        />
                        {hide ? (
                          <div className="input-group-append">
                            <span
                              className="input-group-text bg-transparent border-0"
                              onClick={() => onHide(false)}
                            >
                              <FontAwesomeIcon icon={faEyeSlash} fixedWidth />
                            </span>
                          </div>
                        ) : (
                          <div className="input-group-append">
                            <span
                              className="input-group-text bg-transparent border-0"
                              onClick={() => onHide(true)}
                            >
                              <FontAwesomeIcon icon={faEye} fixedWidth />
                            </span>
                          </div>
                        )}
                      </div>
                      {err.new_password && (
                        <small className="form-text text-danger">{err.new_password}</small>
                      )}
                      <div className="input-group row mb-3 input-group-lg input-control">
                        <div className="input-group-prepend ">
                          <span className="input-group-text bg-transparent text-secondary  border-0">
                            <FontAwesomeIcon icon={faLock} fixedWidth />
                          </span>
                        </div>
                        <input
                          type={hide1 ? "password" : "text"}
                          name="new_password"
                          value={state.password}
                          autoComplete="off"
                          className="form-control col border-0 bg-transparent input-f"
                          style={{ fontSize: 18 }}
                          placeholder="请输入新密码"
                          onChange={(e) =>
                            dispatch({
                              type: "set",
                              payload: {
                                key: "password",
                                value: e.target.value,
                              },
                            })
                          }
                        />
                        {hide1 ? (
                          <div className="input-group-append">
                            <span
                              className="input-group-text bg-transparent border-0"
                              onClick={() => onHide1(false)}
                            >
                              <FontAwesomeIcon icon={faEyeSlash} fixedWidth />
                            </span>
                          </div>
                        ) : (
                          <div className="input-group-append">
                            <span
                              className="input-group-text bg-transparent border-0"
                              onClick={() => onHide1(true)}
                            >
                              <FontAwesomeIcon icon={faEye} fixedWidth />
                            </span>
                          </div>
                        )}
                      </div>
                      {err.password2 && (
                        <small className="form-text text-danger">{err.password2}</small>
                      )}
                      <div className="input-group row mb-3 input-group-lg input-control">
                        <div className="input-group-prepend ">
                          <span className="input-group-text bg-transparent text-secondary  border-0">
                            <FontAwesomeIcon icon={faLock} fixedWidth />
                          </span>
                        </div>
                        <input
                          type={hide2 ? "password" : "text"}
                          name="password2"
                          value={state.password2}
                          className="form-control col border-0  bg-transparent input-f"
                          style={{ fontSize: 18 }}
                          autoComplete="off"
                          placeholder="请确认新密码"
                          onChange={(e) =>
                            dispatch({
                              type: "set",
                              payload: {
                                key: "password2",
                                value: e.target.value,
                              },
                            })
                          }
                        />
                        {hide2 ? (
                          <div className="input-group-append">
                            <span
                              className="input-group-text bg-transparent border-0"
                              onClick={() => onHide2(false)}
                            >
                              <FontAwesomeIcon icon={faEyeSlash} fixedWidth />
                            </span>
                          </div>
                        ) : (
                          <div className="input-group-append">
                            <span
                              className="input-group-text bg-transparent border-0"
                              onClick={() => onHide2(true)}
                            >
                              <FontAwesomeIcon icon={faEye} fixedWidth />
                            </span>
                          </div>
                        )}
                      </div>
                      {err.code && <small className="form-text text-danger">{err.code}</small>}
                      <div className="input-group row mb-3 input-group-lg input-control">
                        <input
                          type="text"
                          name="code"
                          value={state.code}
                          className="form-control col border-0  bg-transparent input-f"
                          style={{ fontSize: 18 }}
                          placeholder="验证码"
                          onChange={(e) =>
                            dispatch({
                              type: "set",
                              payload: { key: "code", value: e.target.value },
                            })
                          }
                        />
                        <div className="input-group-append">
                          {verifyType === "email" ? (
                            count.flag ? (
                              <button
                                type="button"
                                className="col btn btn-sm btn-outline-primary text-primary border-0"
                                disabled={checkEmail()}
                                onClick={handleCode}
                                style={{ fontSize: 14 }}
                              >
                                发送验证码
                              </button>
                            ) : (
                              <button
                                type="button"
                                style={{ fontSize: 14 }}
                                disabled="disabled"
                                className="col btn btn-primary text-white btn-sm border-0"
                              >
                                已发送{count.countdown}s
                              </button>
                            )
                          ) : count.flag ? (
                            <button
                              type="button"
                              className="col btn btn-sm btn-outline-primary text-primary border-0"
                              disabled={!checkPhone()}
                              onClick={handleSendSmsCode}
                              style={{ fontSize: 14 }}
                            >
                              发送验证码
                            </button>
                          ) : (
                            <button
                              type="button"
                              style={{ fontSize: 14 }}
                              disabled="disabled"
                              className="col btn btn-primary text-white btn-sm border-0"
                            >
                              已发送{count.countdown}s
                            </button>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="form-group row">
                    <button
                      type="button"
                      style={{ width: "80%" }}
                      className="btn btn-block mx-auto rounded-pill button-background text-white"
                      onClick={handleRecover}
                    >
                      确&nbsp;定
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
